import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_UPDATE_ATTACHMENT_DATA_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_ATTACHMENT_DATA_SUCCESS`;
export const PHOTO_CAPTURE_UPDATE_ATTACHED_ARTIFACT_ID_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_ATTACHED_ARTIFACT_ID_SUCCESS`;
export const photoCaptureUpdateAttachmentDataSuccessAction = attachmentInfo => ({
    type: PHOTO_CAPTURE_UPDATE_ATTACHMENT_DATA_SUCCESS,
    payload: attachmentInfo
});
export const photoCaptureUpdateAttachedArtifactIdSuccessAction = attachedArtifactIds => ({
    type: PHOTO_CAPTURE_UPDATE_ATTACHED_ARTIFACT_ID_SUCCESS,
    payload: attachedArtifactIds
});
//# sourceMappingURL=photoCaptureUpdateAttachmentAction.js.map